// jquery
$(document).ready(() => {
  const isRTL = $('#content-wrapper').attr('dir') === 'rtl';
  const $el = $(`.r7-preorder__benefits--list`);
  const itemsLength = $el.find('.r7-preorder__benefits--item').length;
  const settings = {
    dots: true,
    customPaging: () => $('<button type="button" />'),
    arrows: false,
    infinite: false,
    variableWidth: true,
    mobileFirst: true,
    centerMode: true,
    rtl: isRTL,
    responsive: [
      {
        breakpoint: 767,
        settings: 'unslick',
      },
    ],
  };

  // let intersecting = false;
  let initialIntersected = false;
  $el.observe(
    (evt) => {
      if (evt[0].isIntersecting) {
        // intersecting = true;
        if (!initialIntersected) {
          TweenMax.staggerFromTo(
            '.r7-preorder__benefits--item',
            0.6,
            {
              opacity: 0,
              y: 150,
            },
            {
              opacity: 1,
              y: 0,
            },
            0.15
          );
          initialIntersected = true;
        }
      }
      // else {
      //   intersecting = false;
      // }
    },
    { threshold: 0 }
  );

  // $el.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  //   if (intersecting && nextSlide !== currentSlide) {
  //     window.handleImpressionTracking($(slick.$slides[nextSlide]));
  //   }
  // });

  // init slick
  if (itemsLength > 1) {
    $el.slick(settings);
    $(window).on('resize', () => {
      // Reslick only if it's not slick()
      if (!$el.hasClass('slick-initialized')) {
        $el.slick(settings);
      }
    });
  }
});
